import React from 'react'
import { FormattedMessage } from 'react-intl'

import { Icon } from '../../../../../../../../atoms'

export const BigCalendarICalendarCell = () => {
  return (
    <div className='flex flex-col items-center gap-1 text-center text-xs font-bold text-grey-700'>
      <Icon name='calendar-disabled' size={12} />
      <FormattedMessage
        id='ui.BigCalendarICalendarCell.unavailability'
        defaultMessage='Indisponibilité iCalendar'
      />
    </div>
  )
}
